export default __webpack_public_path__ + "static/media/direction.1a70e1c3.svg";